import { QueryCache, QueryClient } from '@tanstack/react-query';
import { UnauthorizedError } from './api-client';

export const queryCache = new QueryCache();

export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: (retryCount, error) => {
        // prevent retrying when user is unauthorized, since it is pointless
        // this helps provide faster feedback to the user, immediately logging out
        if (error instanceof UnauthorizedError) {
          return false;
        }

        return retryCount < 3;
      },
    },
  },
});
